import { MODULE_NAME } from "../moduleName";

export const LOADING_LINKEDRECORDS = `${MODULE_NAME}/LOADING_LINKEDRECORDS`;
export const LOADED_LINKEDRECORDS = `${MODULE_NAME}/LOADED_LINKEDRECORDS`;
export const WAIT_LINKED_RECORDS = `${MODULE_NAME}/WAIT_LINKED_RECORDS`;
export const CREATE_LINKED_RECORD = `${MODULE_NAME}/CREATE_LINKED_RECORD`;
export const CREATING_LINKED_RECORD = `${MODULE_NAME}/CREATING_LINKED_RECORD`;
export const REMOVING_LINKED_RECORD = `${MODULE_NAME}/REMOVING_LINKED_RECORD`;